import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/theme/imgs/logo_completo.svg'
import _imports_1 from '@/theme/imgs/logo_mark.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0ab5d2ba")

_pushScopeId("data-v-0ab5d2ba")
const _hoisted_1 = { class: "sidenav" }
const _hoisted_2 = { class: "top p-d-flex p-flex-column p-mb-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "logo-img p-mb-3" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo-img-hover",
    src: _imports_0,
    alt: "",
    loading: "lazy",
    height: "30"
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "logo-img-blur",
    src: _imports_1,
    alt: "",
    loading: "lazy",
    height: "30"
  })
], -1)
const _hoisted_4 = { class: "icon material-icons-outlined" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "bottom p-mt-auto" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon material-icons" }, " help_outline ", -1)
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon material-icons-outlined" }, " account_circle ", -1)
const _hoisted_11 = { class: "label p-d-flex p-flex-column" }
_popScopeId()

import { downloadFile } from "@/services/files.service";
import { useStore } from "@/store/store";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";


export default _defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const myClub = computed(() => {
  return store.getters.getMyClub;
});

function downloadFileFromS3() {
  downloadFile(
    process.env.VUE_APP_WESMASH_GUIDE_LINK,
    "MANUALE DI UTILIZZO WESMASH.pdf"
  );
}
const user = computed(function () {
  return store.getters.getUser;
});

const sideNavButtons = computed(() => [
  {
    nav: "Scheduler",
    label: "bookings",
    icon: "calendar_today",
    condition: true,
  },
  {
    nav: "Users",
    label: "users",
    icon: "people",
    condition: true,
  },
  {
    nav: "MyClub",
    label: "my_club",
    icon: "sports_baseball",
    condition: true,
  },
  {
    nav: "Stats",
    label: "stats",
    icon: "insert_chart_outlined",
    condition: true,
  },
  {
    nav: "Tournaments",
    label: "tournaments",
    icon: "emoji_events",
    condition: true,
  },
  {
    nav: "open-bookings",
    label: "partite",
    icon: "sports_tennis",
    condition: false,
  },
  {
    nav: "payments",
    label: "pagamenti",
    icon: "payments",
    condition: true,
  },
  {
    nav: "memberships",
    label: "Membership",
    icon: "verified",
    condition: myClub.value.membership_attiva,
  },
].filter(item => !!item.condition));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(sideNavButtons), (button, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: index,
          class: "link",
          to: { name: button.nav }
        }, {
          default: _withId(() => [
            _createVNode("span", _hoisted_4, _toDisplayString(button.icon), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(_unref(t)(button.label)), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("a", {
        class: "link",
        href: "#",
        onClick: _withModifiers(downloadFileFromS3, ["prevent"])
      }, [
        _hoisted_7,
        _createVNode("span", _hoisted_8, _toDisplayString(_unref(t)('guide')), 1)
      ], 8, ["onClick"]),
      _hoisted_9,
      _createVNode(_component_router_link, {
        class: "link",
        to: { name: 'MyProfile' }
      }, {
        default: _withId(() => [
          _hoisted_10,
          _createVNode("span", _hoisted_11, [
            _createVNode("span", null, _toDisplayString(_unref(user).nome), 1),
            _createVNode("span", null, _toDisplayString(_unref(user).cognome), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})